'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconButton = require('./IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Spinner = require('../../../../../../../components/loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

require('./IconList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIsActive = function getIsActive(selectedElements, icon) {
    var isActive = true;
    selectedElements.forEach(function (element) {
        var elementIconId = element.getIn(['content', 'icon', 'id']);
        var iconId = icon && icon.get('id');
        isActive = isActive && !elementIconId && !iconId || iconId && elementIconId === iconId;
    });
    return isActive;
};

var IconListLoading = function IconListLoading(props) {
    return _react2.default.createElement(
        'div',
        { className: 'IconList' },
        _react2.default.createElement(
            'div',
            { className: 'iconlist-loading' },
            _react2.default.createElement(_Spinner2.default, { show: true })
        )
    );
};

var IconListEmpty = function IconListEmpty(_ref) {
    var popupQuery = _ref.popupQuery,
        setModeDefault = _ref.setModeDefault;
    return _react2.default.createElement(
        'div',
        { className: 'IconList' },
        _react2.default.createElement(
            'div',
            { className: 'iconlist-loading' },
            _react2.default.createElement(
                'div',
                { className: 'no-results' },
                _react2.default.createElement(
                    'p',
                    null,
                    'No icons found for "',
                    popupQuery,
                    '".'
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: '#', onClick: setModeDefault },
                        'See recommended icons'
                    )
                )
            )
        )
    );
};

IconListEmpty.propTypes = {
    popupQuery: _propTypes2.default.string,
    setModeDefault: _propTypes2.default.func
};

var IconListResults = function IconListResults(props) {
    return _react2.default.createElement(
        'div',
        { className: 'IconList' },
        _react2.default.createElement(
            'ul',
            null,
            props.iconList.map(function (icon, i) {
                return _react2.default.createElement(
                    'li',
                    { key: i },
                    _react2.default.createElement(_IconButton2.default, _extends({}, props, { icon: icon, isActive: getIsActive(props.selectedElements, icon) }))
                );
            })
        )
    );
};

IconListResults.propTypes = {
    iconList: _propTypes2.default.object,
    selectedElements: _propTypes2.default.object
};

var IconList = function IconList(props) {
    var iconList = props.iconList;


    if (!iconList) return _react2.default.createElement(IconListLoading, props);
    if (!iconList.size) return _react2.default.createElement(IconListEmpty, props);
    return _react2.default.createElement(IconListResults, props);
};

IconList.propTypes = {
    iconList: _propTypes2.default.object
};

exports.default = IconList;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/tabContent/iconList/IconList.js
// module id = 2242
// module chunks = 0